import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: false
})
export class CapitalizePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return value.toString().replace('_', ' ').toLowerCase();
  }

}
